export default "__VITE_ASSET__BG7dISyf__"